import React from "react";
import ReactSelect from "react-select";

const CatalogSelect = ({ options = [], value, onChange, inputId, disabled = false, loading = false, invalid = false, placeholder = "Seleccione", disabledOptionIds = [], clearable = false }) => (
  <ReactSelect
    inputId={inputId}
    aria-label={inputId}
    aria-invalid={invalid || undefined}
    className={`prereg-select${invalid ? " is-invalid" : ""}`}
    classNamePrefix="dhn-select"
    options={options}
    getOptionValue={(option) => String(option.id)}
    getOptionLabel={(option) => option.name}
    value={options.find((option) => String(option.id) === String(value)) || null}
    onChange={(option) => onChange(option ? String(option.id) : "")}
    isOptionDisabled={(option) => disabledOptionIds.some(
      (id) => String(id) === String(option.id),
    )}
    isClearable={clearable}
    isDisabled={disabled}
    isLoading={loading}
    placeholder={placeholder}
    noOptionsMessage={() => "No hay opciones disponibles"}
    loadingMessage={() => "Cargando..."}
    menuPlacement="auto"
  />
);

export default CatalogSelect;
